/** REV-22155 — company or natural person; on tasks and templates a missing value means COMPANY. */
export enum SubjectType {
    COMPANY = 'COMPANY',
    PERSON = 'PERSON',
}
